export default theme => ({
	drawer: {
		width: "20vw",
		flexShrink: 0
		// minWidth: 300
		// boxShadow: "none"
	},
	drawerPaper: {
		width: "20vw",
		height: "100%",
		// boxShadow: "none",
		padding: theme.spacing.unit * 1.5
		// minWidth: 300
	},
	wrapper: {
		paddingBottom: theme.spacing.unit * 10
	},
	card: {
		marginBottom: theme.spacing.unit * 2
	},
	toolbar: theme.mixins.toolbar,
	content: {
		"&$expanded": {
			margin: 0
			// padding: 8
		}
	},
	expanded: {
		// margin: `0 0 ${theme.spacing.unit}px 0`
	},
	panelRoot: {
		marginBottom: theme.spacing.unit * 2.5,
		boxShadow: "none"
	},
	panelSummaryRoot: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.common.white,
		boxShadow: theme.shadows[1],
		"&:hover": {
			boxShadow: theme.shadows[3]
		},
		minHeight: "auto",
		"&$expanded": {
			padding: `0 ${theme.spacing.unit * 3}px`,
			margin: 0,
			minHeight: "auto"
		},
		"&$expanded div:first-child": {
			margin: "12px 0"
		}
	},
	panelSummaryHeading: {
		color: theme.palette.common.white,
		fontSize: "1rem",
		"&$expanded": {
			marginLeft: 20
		}
	},
	panelSummaryIcon: {
		color: theme.palette.common.white
	},
	panelDetails: {
		display: "block",
		padding: `${theme.spacing.unit}px 0 0 0`
		// maxHeight: 400,
		// overflowY: "scroll"
	},
	resultHeaderAppBar: {
		marginBottom: theme.spacing.unit * 3,
		boxShadow: "none"
	},
	resultHeaderToolbar: {
		padding: 0,
		alignItems: "center"
	},
	resultHeaderToolbarContainer: {
		justifyContent: "space-between"
	},
	resultHeaderActions: {
		width: "100%",
		textAlign: "right"
	},
	resultHeaderCount: {
		color: theme.palette.primary.main,
		fontWeight: "600",
		marginRight: theme.spacing.unit / 2,
		fontSize: "1.3rem"
	},
	resultHeaderTitle: {
		fontWeight: "600",
		marginRight: theme.spacing.unit / 2
	},
	resultHeaderButton: {
		backgroundColor: theme.palette.background.default,
		marginRight: theme.spacing.unit / 4,
		"&:last-child": {
			marginRight: 0
		},
		padding: `${theme.spacing.unit / 4}px ${theme.spacing.unit - 2}px`,
		fontSize: "0.8rem",
		height: "auto",
		"@media (max-width:1440px)": {
			fontSize: "0.65rem"
		},
		"@media (max-width:960px)": {
			fontSize: "0.8rem"
		}
	},
	resultHeaderIcon: {
		fill: theme.palette.primary.main,
		width: 14,
		height: 14,
		marginRight: theme.spacing.unit / 4,
		"@media (max-width:1440px)": {
			width: 10,
			height: 10
		},
		"@media (max-width:960px)": {
			width: 16,
			height: 16
		}
	},
	paper: {
		marginBottom: 8,
		padding: "12px 8px",
		backgroundColor: theme.palette.primary.main,
		color: "white",
		cursor: "pointer",
		"&.active-poi": {
			backgroundColor: theme.palette.secondary.main
		}
	},
	[theme.breakpoints.down("sm")]: {
		drawer: {
			width: "100vw"
		},
		drawerPaper: {
			width: "100vw"
		},
		resultHeaderIcon: {
			width: 16,
			height: 16
		},
		resultHeaderTitle: {
			marginBottom: theme.spacing.unit / 2
		}
	}
});
